const state = {
    cIndustry: null,
    cMarketArea: null,
    cSalesClass: null,
    cFavoriteSalesClass: [],
    cFavoriteIndustries: [],
    cFavoriteMarketAreas: [],
    cSearchInputIndustry: null,
    cSearchInputMarketArea: null,
    cSearchIndustries: [],
    cSearchMarketAreas: [],
    cSearchLoadingIndustry: false,
    cSearchLoadingMarketArea: false,
    cProfileId: 0,

};

const mutations = {
  C_SET_INDUSTRY: (state, cIndustry) => {
    state.cIndustry = cIndustry;
  },
  C_SET_MARKET_AREA: (state, cMarketArea) => {
    state.cMarketArea = cMarketArea;
  },
  C_SET_SALES_CLASS: (state, cSalesClass) => {
    state.cSalesClass = cSalesClass;
  },
  C_SET_PROFILE_ID: (state, cProfileId) => {
    state.cProfileId = cProfileId;
  },
  C_SET_FAVORITE_INDUSTRIES: (state, cIndustry) => {
    state.cFavoriteIndustries = cIndustry;
  },
  C_SET_FAVORITE_MARKET_AREAS: (state, cMarketArea) => {
    state.cFavoriteMarketAreas = cMarketArea;
  },
  C_SET_FAVORITE_SALES_CLASSES: (state, cSalesClass) => {
    state.cFavoriteSalesClass = cSalesClass;
  },
  C_SET_SEARCH_INPUT_INDUSTRY: (state, cSearchInputIndustry) => {
    state.cSearchInputIndustry = cSearchInputIndustry;
  },
  C_SET_SEARCH_INPUT_MARKET_AREA: (state, cSearchInputMarketArea) => {
    state.cSearchInputMarketArea = cSearchInputMarketArea;
  },
  C_SET_SEARCH_INDUSTRIES: (state, cSearchIndustries) => {
    state.cSearchIndustries = cSearchIndustries;
  },
  C_SET_SEARCH_MARKET_AREAS: (state, cSearchMarketAreas) => {
    state.cSearchMarketAreas = cSearchMarketAreas;
  },
  C_SET_SEARCH_LOADING_INDUSTRY: (state, cSearchLoadingIndustry) => {
    state.cSearchLoadingIndustry = cSearchLoadingIndustry;
  },
  C_SET_SEARCH_LOADING_MARKET_AREA: (state, cSearchLoadingMarketArea) => {
    state.cSearchLoadingMarketArea = cSearchLoadingMarketArea;
  },
  C_PUSH_TO_FAVORITE_INDUSTRIES: (state, cIndustry) => {
    state.cFavoriteIndustries.push(cIndustry);
  },
  C_PUSH_TO_FAVORITE_MARKET_AREAS: (state, cMarketArea) => {
    state.cFavoriteMarketAreas.push(cMarketArea);
  },
  C_PUSH_TO_FAVORITE_SALES_CLASSES: (state, cSalesClass) => {
    state.cFavoriteSalesClass.push(cSalesClass);
  },
};

const getters = {
    cIndustry: (state) => state.cIndustry,
    cMarketArea: (state) => state.cMarketArea,
    cSalesClass: (state) => state.cSalesClass,
    cProfileId: (state) => state.cProfileId,
    cFavoriteIndustries: (state) => state.cFavoriteIndustries,
    cFavoriteMarketAreas: (state) => state.cFavoriteMarketAreas,
    cFavoriteSalesClass: (state) => state.cFavoriteSalesClass,
    cSearchInputIndustry: (state) => state.cSearchInputIndustry,
    cSearchInputMarketArea: (state) => state.cSearchInputMarketArea,
    cSearchIndustries: (state) => state.cSearchIndustries,
    cSearchMarketAreas: (state) => state.cSearchMarketAreas,
    cSearchLoadingIndustry: (state) => state.cSearchLoadingIndustry,
    cSearchLoadingMarketArea: (state) => state.cSearchLoadingMarketArea,
};

const companySelection = {
    state,
    getters,
    mutations,
};

export default companySelection;